import { useState } from "react";
import { NavSectionConfig } from "../types/navbar";

export function useMegaMenu(sections: NavSectionConfig[]) {
  const [openSection, setOpenSection] = useState<NavSectionConfig | null>(null);
  const [slideDir, setSlideDir] = useState(1);
  const [isSwitching, setIsSwitching] = useState(false);

  const toggleSection = (section: NavSectionConfig) => {
    setOpenSection((prev) => {
      if (prev && prev.title !== section.title) {
        const prevIdx = sections.findIndex((s) => s.title === prev.title);
        const nextIdx = sections.findIndex((s) => s.title === section.title);
        setSlideDir(nextIdx >= prevIdx ? 1 : -1);
        setIsSwitching(true);
      } else {
        setIsSwitching(false);
      }
      return prev?.title === section.title ? null : section;
    });
  };

  const closeSection = () => setOpenSection(null);

  return { openSection, slideDir, isSwitching, toggleSection, closeSection };
}
